import styled from "@emotion/styled";

import { MDSIcon } from "@/mds";
import {
  getAgentStatusIconKind,
  normalizeStatusValue,
} from "@/pages/agent/utils/agent-status.utils";
import { AssistantTaskStatus } from "@/store/assistant/types";

export const AgentTaskStateIcon = ({ status, size = 16 }: { status: string; size?: number }) => {
  const normalizedStatus = normalizeStatusValue({ status });
  const completed = normalizedStatus === AssistantTaskStatus.Completed;

  return (
    <StyledWrapper $completed={completed}>
      <MDSIcon kind={getAgentStatusIconKind({ status: normalizedStatus })} size={size} />
    </StyledWrapper>
  );
};

const StyledWrapper = styled.span<{ $completed: boolean }>`
  color: ${({ $completed, theme }) =>
    $completed ? theme.colors.text.positive : theme.colors.text.tertiary};
  display: inline-flex;
  flex: 0 0 auto;
`;
